import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { intersections } from "../data/taxonomy";
import { posts } from "../data/posts";
import PostCard from "../components/cards/PostCard";
import "../styles/archive-page.css";

const IntersectionPage = () => {
  const { intersectionId } = useParams();

  const intersection = useMemo(
    () => intersections.find((entry) => entry.id === intersectionId),
    [intersectionId]
  );

  const filteredPosts = posts.filter((post) => post.intersections.includes(intersectionId));

  return (
    <div className="archive-page page-shell">
      <section className="archive-page__header">
        <span className="page-eyebrow">Intersection Archive</span>
        <h1>{intersection ? intersection.title : "Unknown Intersection"}</h1>
        <p>{intersection ? intersection.excerpt : "Hybrid writings that cross categories."}</p>
      </section>

      <section className="archive-page__grid">
        {filteredPosts.map((post) => (
          <PostCard key={post.slug} post={post} />
        ))}
      </section>
    </div>
  );
};

export default IntersectionPage;